<p-card class="h-full">
  <ng-template pTemplate="title">
    <div class="flex flex-1 align-items-center gap-2">
      <div class="flex-1">{{ title }}</div>
      @if (editable) {
        <p-button icon="pi pi-pencil" [text]="true" severity="secondary" [label]="i18n?.i18nLng()['EDIT']" [ariaLabel]="i18n?.i18nLng()['EDIT'] + ': ' + title" (click)="onEdit.emit(true)"/>
      }
    </div>
  </ng-template>
  <p-table [value]="tableData"
           class="mt-2">
    <ng-template pTemplate="body" let-data>
      <tr>
        <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis pl-0"
            [ngClass]="data?.titleStyleClass ? data.titleStyleClass : null"
            [colSpan]="data?.titleColspan ? 2 : 1"
            [width]="titleColumnWidth">
            {{ data?.i18nTitleKey ? i18n.i18nLng()[data.i18nTitleKey] : data?.title }}
        </td>
        @switch (data?.valueType) {
          @case ('STATE') {
            <td class="flex gap-2 align-items-center">
              <sps-payment-status-tag [status]="data.value"></sps-payment-status-tag>
              @if (data.value === 'TEST') {
                <a class="sps-link" href="https://docs.girocheckout.de/testdaten/" target="_blank">{{ i18n.i18nLng()['SHOWTESTDATA'] }}</a>
              }
            </td>
          }
          @case ('PASSWORD') {
            <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis"
                [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                [width]="valueColumnWidth">
              <sps-masked-password [password]="data?.value"
                                   [showPassword]="showPassword">
              </sps-masked-password>
            </td>
          }
          @default {
            @if (!data?.titleColspan) {
              <td class="white-space-nowrap overflow-hidden text-overflow-ellipsis"
                  [ngClass]="data?.valueStyleClass ? data.valueStyleClass : null"
                  [width]="valueColumnWidth">
                {{ data?.i18nValueKey ? i18n.i18nLng()[data.i18nValueKey] : data?.value }}
              </td>
            }
          }
        }
      </tr>
    </ng-template>
  </p-table>
</p-card>
